export default __webpack_public_path__ + "static/media/remove-feature.725a4a7e.svg";